import $api from "../http";
import {
  IRevenueStatistics,
  ISummaryStatistics,
  StatsRevenuePeriodsEnum,
} from "../models/Statistics";

class StatisticsServiceClass {
  async getSummary() {
    return await $api.get<ISummaryStatistics>(`api/statistics/summary`);
  }

  async getRevenue(period: StatsRevenuePeriodsEnum) {
    return await $api.get<IRevenueStatistics[]>(`api/statistics/revenue?period=${period}`);
  }
}

export const StatisticsService = new StatisticsServiceClass();
